/**
 * Mobile Navigation Component
 * Handles separate mobile navigation component toggle
 */
(function ($) {
  'use strict';

  function initMobileNav() {
    const $toggle = $(".mobile-toggle-cta");
    const $mobileNav = $("#mobile_nav");
    const $body = $("body");

    if ($toggle.length === 0 || $mobileNav.length === 0) {
      return; // Elements don't exist
    }

    // Ensure mobile nav starts closed
    $mobileNav.removeClass("is-open");
    $toggle.addClass("collapsed").attr("aria-expanded", "false");
    $body.removeClass("mobile-nav-open").css("overflow", "auto");

    // Remove any existing handlers to prevent duplicates
    $toggle.off("click.mobileNav");

    // Toggle mobile nav
    $toggle.on("click.mobileNav", function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = $(this).attr("aria-expanded") === "true";

      if (isExpanded) {
        // Close nav
        $mobileNav.removeClass("is-open");
        $toggle.addClass("collapsed").attr("aria-expanded", "false");
        $body.removeClass("mobile-nav-open").css("overflow", "auto");
      } else {
        // Open nav
        $mobileNav.addClass("is-open");
        $toggle.removeClass("collapsed").attr("aria-expanded", "true");
        $body.addClass("mobile-nav-open").css("overflow", "hidden");
      }
    });

    // Close nav when clicking a menu item (using new class names)
    $(document).off("click.mobileNav", "#mobile_nav .mobile-nav__link:not(.mobile-nav__toggle)");
    $(document).on("click.mobileNav", "#mobile_nav .mobile-nav__link:not(.mobile-nav__toggle)", function () {
      $mobileNav.removeClass("is-open");
      $toggle.addClass("collapsed").attr("aria-expanded", "false");
      $body.removeClass("mobile-nav-open").css("overflow", "auto");
    });
  }

  // Initialize on DOM ready
  $(document).ready(function () {
    initMobileNav();
  });

  // Re-initialize on window load in case DOM changes
  $(window).on("load", function () {
    initMobileNav();
  });
})(jQuery);

